import 'regenerator-runtime/runtime';


import StoreLocator from './stores/store-locator';
import FindStores from './stores/whatsapp';

export { FindStores, StoreLocator};
